'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowAddressAutocomplete = function (_React$Component) {
    _inherits(WorkflowAddressAutocomplete, _React$Component);

    function WorkflowAddressAutocomplete() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WorkflowAddressAutocomplete);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WorkflowAddressAutocomplete.__proto__ || Object.getPrototypeOf(WorkflowAddressAutocomplete)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (code, value) {
            var elements = [];
            var isMailingAddress = _this.props.component.code === 'MailingAddressLocationAutocomplete';
            var countryCode = (0, _metrixCommon.getElementValueByCode)(_this.props.component.elements, 'CountryCode');

            if (code === 'address') {
                elements.push({ code: 'Code', value: value.code });
                elements.push({ code: 'ApartmentSuite', value: value.apartmentSuite });
                elements.push({ code: 'StreetNumber', value: value.streetNumber });
                elements.push({ code: 'Street', value: value.street });
                elements.push({ code: 'City', value: value.city });
                elements.push({ code: 'Municipality', value: value.municipality });
                elements.push({ code: 'State', value: value.state });
                elements.push({ code: 'StateCode', value: value.stateCode });
                elements.push({
                    code: 'Country',
                    value: isMailingAddress && countryCode ? _this.countryCodeToCountry(countryCode) : value && value.country ? value.country : 'United States'

                });
                elements.push({
                    code: 'CountryCode',
                    value: isMailingAddress && countryCode ? countryCode : value && value.countryCode ? value.countryCode : 'USA'
                });
                elements.push({ code: 'PostalCode', value: value.postalCode });
                elements.push({ code: 'FormattedAddress', value: value.formattedAddress });
                elements.push({ code: 'Description', value: value.description });
                elements.push({ code: 'Latitude', value: value.location.latitude });
                elements.push({ code: 'Longitude', value: value.location.longitude });
                _this.props.doSetReturn({
                    componentCode: _this.props.component.code,
                    code: null,
                    value: elements
                });
            } else {
                if (code.startsWith('location.')) {
                    code = code.replace('location.', '');
                }
                _this.props.doSetReturn({
                    componentCode: _this.props.component.code,
                    code: code[0].toUpperCase() + code.slice(1),
                    value: value
                });
            }
        }, _this.getAddress = function (elements) {
            var address = null;
            if (elements) {
                address = {};
                address.code = (0, _metrixCommon.getElementValueByCode)(elements, 'Code');
                address.apartmentSuite = (0, _metrixCommon.getElementValueByCode)(elements, 'ApartmentSuite');
                address.streetNumber = (0, _metrixCommon.getElementValueByCode)(elements, 'StreetNumber');
                address.street = (0, _metrixCommon.getElementValueByCode)(elements, 'Street');
                address.city = (0, _metrixCommon.getElementValueByCode)(elements, 'City');
                address.municipality = (0, _metrixCommon.getElementValueByCode)(elements, 'Municipality');
                address.state = (0, _metrixCommon.getElementValueByCode)(elements, 'State');
                address.stateCode = (0, _metrixCommon.getElementValueByCode)(elements, 'StateCode');
                address.country = (0, _metrixCommon.getElementValueByCode)(elements, 'Country');
                address.countryCode = (0, _metrixCommon.getElementValueByCode)(elements, 'CountryCode');
                address.postalCode = (0, _metrixCommon.getElementValueByCode)(elements, 'PostalCode');
                address.formattedAddress = (0, _metrixCommon.getElementValueByCode)(elements, 'FormattedAddress');
                address.description = (0, _metrixCommon.getElementValueByCode)(elements, 'Description');
                address.location = {};
                address.location.latitude = (0, _metrixCommon.getElementValueByCode)(elements, 'Latitude');
                address.location.longitude = (0, _metrixCommon.getElementValueByCode)(elements, 'Longitude');
            }
            return address;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WorkflowAddressAutocomplete, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return true;
        }
    }, {
        key: 'countryCodeToCountry',
        value: function countryCodeToCountry(code) {
            if (code) {
                var countryCode = String(code).toLowerCase();
                switch (countryCode) {
                    case 'us':
                    case 'usa':
                        return 'United States';
                    case 'ca':
                    case 'can':
                    default:
                        return 'Canada';
                }
            }
            return 'Canada';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _metrixCommon.Container,
                null,
                _react2.default.createElement(_metrixCommon.AddressAutocomplete, _extends({}, this.props, {
                    address: this.getAddress(this.props.return && this.props.return.elements),
                    placeholder: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Placeholder'),
                    references: this.props.reference.references,
                    referencesEvent: this.props.reference.doGetReferences,
                    changeEvent: function changeEvent(code, value) {
                        return _this2.handleChange(code, value);
                    },
                    label: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Label'),
                    allowManual: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'AllowManual') === 'yes',
                    allowInternational: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'AllowInternational') === 'yes',
                    countryCode: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'CountryCode'),
                    allowApartmentSuite: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'AllowApartmentSuite') === 'yes',
                    reset: this.props.component.reset
                }))
            );
        }
    }]);

    return WorkflowAddressAutocomplete;
}(_react2.default.Component);

exports.default = WorkflowAddressAutocomplete;